<template>
  <v-container fluid>
    <ActionBar />

    <div :class="[
      'page__content',
      {
        'page__content--from-v4': noMainMenuFromV4
      }]">
      <v-tabs
        v-model="activeTab"
        slider-color="secondary"
        class="v-tabs-reports"
        :class="{ 'v-tabs-reports__hidden': !hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS') || !hasRole('billing', 'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER') }"
      >
        <v-tab v-show="hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS')" ripple>
          {{ $t(`${namespace}.paymentStatus`) }}
        </v-tab>

        <v-tab v-show="hasRole('billing', 'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER')" ripple>
          {{ $t(`${namespace}.importedSpreadsheets`) }}
        </v-tab>

        <v-tabs-items touchless>
          <v-tab-item v-if="hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS')">
            <PendingPayments v-if="activeTab === 0" />
          </v-tab-item>

          <v-tab-item v-if="hasRole('billing', 'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER')">
            <ImportedSpreadsheets v-if="activeTab === 1" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-container>
</template>

<script>
import { hasRole } from 'utils/functions'
import { mapState } from 'vuex'
import ActionBar from 'components/approvePayment/ActionBar'
import PendingPayments from 'components/approvePayment/pendingPayments'
import ImportedSpreadsheets from 'components/approvePayment/importedSpreadsheets'

export default {
  name: 'IncentivesPage',
  components: {
    ActionBar,
    PendingPayments,
    ImportedSpreadsheets
  },
  computed: {
    ...mapState({
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    })
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      activeTab: 0
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleActiveTab () {
      if (
        this.hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS') &&
        this.hasRole('billing', 'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER')
      ) {
        this.activeTab = 0
        return
      }

      if (
        !this.hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS') &&
        this.hasRole('billing', 'ROLE_GET_MASSIVE_ORDER_PAYMENT_STATUS_WORKER')
      ) {
        this.activeTab = 1
      }
    }
  },
  mounted () {
    this.handleActiveTab()
  }
}
</script>

<style lang="scss">
.route--approvepayment {

  .page__content,
  .v-tabs-reports,
  .v-tabs-reports .v-window,
  .v-tabs-reports .v-window .v-window__container,
  .v-tabs-reports .v-window .v-window__container .v-window-item,
  .v-tabs-reports .v-window .v-window__container .v-window-item > div {
    height: 100%;
  }

  .v-tabs-reports__hidden {

    .v-tabs__bar {
      display: none !important;
    }
  }
}
</style>
